import React from "react";

const BindeleddetLocationMap = () => {
  return (
    <iframe
      title="Google maps"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1785.3248159567038!2d10.402094516170896!3d63.418509683271346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d31959aee2217%3A0xaae41dd908af6fb7!2sBindeleddet%20NTNU!5e0!3m2!1sno!2sno!4v1643208594083!5m2!1sno!2sno"
      width="100%"
      height="300px"
    />
  );
};

export default BindeleddetLocationMap;
